import { render, staticRenderFns } from "./PurchaseButton.vue?vue&type=template&id=6eb22044&"
import script from "./PurchaseButton.vue?vue&type=script&lang=js&"
export * from "./PurchaseButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports